<template>
  <div class="news">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
<!--    <user-nav>-->
<!--      -->
<!--    </user-nav>-->
    <div class="user-center ">
      <div class="news-nav">
        <div class="news-nav-item" v-for="(item, index) in category_list"
             :key="item.id"
             :class="{'active': current === index}"
             @click="onSelectCategory(item.id, index)">
          {{item.name}}
        </div>
      </div>

      <div class="border-card-main">
        <div class="news-list" v-if="!news_info">
          <div class="news-item" v-for="item in newsList" :key="item.id">
            <div class="news-title">{{item.title}}</div>
            <div class="news-desc">{{item.miaoshu}}</div>

            <div class="news-detail-btn" @click="onJumpDetail(item)">查看详情</div>
            <div class="new-footer">
              <span class="news-views">浏览量：{{item.views}}</span>
              <span class="news-time">创建时间：{{item.createtime}}</span>
            </div>
          </div>
        </div>
        <div class="news-detail" v-if="news_info">
          <div class="back-btn" @click="onBack"><i class="el-icon-back"></i>返回</div>
          <div class="news-title">{{news_info.title}}</div>
          <div class="news-info">
            <span>阅读量：{{news_info.views}}</span>
            <span>发布时间：{{news_info.createtime}}</span>
          </div>
          <div v-html="news_info.content"></div>
        </div>
      </div>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {apiNewsIndex} from "../../api/api";

export default {
  name: "help",
  components: {headerNav, userNav, footerBox},
  data(){
    return{
      news_info: false,
      param: {
        limit: 10,
        page: 1,
        id: 0
      },
      current: 0,
      category_list: [],
      newsList: []
    }
  },
  computed:{
    isShow() {
      var show = true
      var hosts = ['dfh.jianuojy.com'];
      for (let i = 0; i < hosts.length; i++) {
        var host = location.host;
        if (hosts[i] === host) {
          show = false;
        }
      }
      return show;
    }
  },
  mounted(){
    this.loadData();
  },
  methods:{
    onBack(){
      this.news_info = false;
    },
    onJumpDetail(row){
      this.news_info = row;
      // this.$router.push("/news/detail?id="+id)
    },
    loadData(){
      apiNewsIndex().then(res => {
        for(let i = 0; i < res.data.category_list.length; i++){
          if(res.data.category_list[i].name === '关于我们' && !this.isShow){
            res.data.category_list.splice(i, 1);
          }
        }
        this.category_list = res.data.category_list;
        this.param.id = this.category_list[0].id
        this.loadChildData();
      })
    },
    onSelectCategory(id, index){
      this.param.id = id;
      this.current = index;
      this.news_info = false;
      this.loadChildData();
    },
    loadChildData(){
      apiNewsIndex(this.param).then(res => {

        this.newsList = res.data.article_list.data;
      })
    }
  }
}
</script>

<style>
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #E4E4E4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.news {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;


  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;
    position: relative;

    .news-nav{
      width: 160px;
      position: absolute;
      left: 0;
      margin-top: 10px;

      .news-nav-item{
        background-color: #ffffff;
        height: 40px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #000000;
        cursor: pointer;

        &.active{
          background-color: #ff4b2b;
          color: #ffffff;
        }
      }
    }


    .border-card-main {
      min-height: calc(100vh - 190px);
      background-color: #ffffff;
      padding: 20px;

      .news-list{

        .news-item{
          margin-bottom: 20px;
          background-color: #f5f6f7;
          padding: 10px;
          cursor: pointer;

          .news-title{
            font-weight: bold;
            color: #000000;
            font-size: 14px;
          }
          .news-desc{
            width: 500px;
            line-height: 20px;
            color: #333333;
            font-size: 12px;
            margin-top: 5px;
          }
          .news-detail-btn{
            float: right;
            background-color: #0f375a;
            padding: 5px 15px;
            color: #ffffff;
            margin-top: -10px;
          }
          .new-footer{
            margin-top: 5px;
            display: flex;

            span{
              display: inline-block;
              margin-right: 20px;
              font-size: 12px;


            }
          }
        }
      }

      .news-detail {

        .back-btn{
          font-weight: bold;
          color: #127AF7;
          cursor: pointer;
        }
        .news-title{
          text-align: center;
          color: #000;
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 5px;
        }
        .news-info{
          text-align: center;
          margin-bottom: 20px;

          span{
            font-size: 12px;
            color: #878787;
            display: inline-block;
            margin: 0 10px;
          }
        }
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/index.vue